import React from 'react';
import { Link } from 'react-router-dom';

/** Comparison teaser — source: mockup L559–568. */
const ComparisonTeaser = (): React.JSX.Element => (
  <section className="oq-teaser">
    <div className="oq-container oq-teaser__inner">
      <div className="oq-teaser__kicker oq-bebas">THINKING OF SWITCHING?</div>
      <h2 className="oq-teaser__title oq-bebas">
        Spond, ConnectMyClub, WebCollect —<br />
        and why clubs move to Olympiq
      </h2>
      <p className="oq-teaser__subtitle">
        We&apos;re doing things differently — deeply focused on a great experience for your
        members, and on making the admin of running your club our job, not yours.
      </p>
      <Link to="/compare" className="oq-teaser__cta">See the full comparison</Link>
    </div>
  </section>
);

export default ComparisonTeaser;
